export function SET_SEARCH (state, search) {
  state.search = search
}

export function RESET_SEARCH (state) {
  state.search = ''
}
